import { useEffect, useState } from "react";
import { API, Endpoints } from "../api/API";
import { Application } from "../interfaces/Interfaces"
import './Contact.css';

const Contact = (props: {
    objectId: string | null,
    userCountry: string | null,
    reason: string,
    appId: string | null,
    setReason: React.Dispatch<React.SetStateAction<string>>,
    translate: () => void,
    setShowContact: React.Dispatch<React.SetStateAction<boolean>>,
    token: string
    contactName: string,
    setContactName: React.Dispatch<React.SetStateAction<string>>,
    contactEmail: string,
    setContactEmail: React.Dispatch<React.SetStateAction<string>>,
    contactOldEmail: string,
    setContactOldEmail: React.Dispatch<React.SetStateAction<string>>,
    message: string,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    applications: Array<Application>
}) => {

    const [applicationId, setApplicationId] = useState<string>(props.appId ? props.appId : '');
    const [sendingRequest, setSendingRequest] = useState<boolean>(false);
    const [oldEmailClassName, setOldEmailClassName] = useState<string>('');

    const handleContactNameChange = (event: any) => { props.setContactName(event?.target.value); }
    const handleContactEmailChange = (event: any) => { props.setContactEmail(event?.target.value); }
    const handleContactOldEmailChange = (event: any) => { props.setContactOldEmail(event?.target.value); }
    const handleMessageChange = (event: any) => { props.setMessage(event?.target.value); }

    useEffect(() => {
        props.translate();
    }, []);

    const ApplicationsOptions = (applications: Array<Application>) => {
        let applicationOptions: JSX.Element[] = [];
        applications.sort((a, b) => a.name <= b.name ? -1 : 1);
        applications.map((item: Application) =>
        (
            applicationOptions.push(<option value={item.id}> {item.name} </option>)
        ));
        return applicationOptions
    }

    const submitForm = async () => {
        var finalMessage = props.message ? props.message : props.reason;
        if (props.reason === "email" || props.reason === "") {
            if (props.contactOldEmail === "") {
                setOldEmailClassName("error");
                return;
            }
            finalMessage = finalMessage + "\n\n My old email address is: " + props.contactOldEmail;
        }
        const body = {
            requesterId: props.objectId,
            country: props.userCountry,
            title: props.reason,
            name: props.contactName,
            email: props.contactEmail,
            message: finalMessage,
            applicationId: applicationId,
            requesterName: props.contactName,
            requesterEmail: props.contactEmail,
        };
        setSendingRequest(true);
        await API.POST(body, Endpoints.WriteSupportRequest, props.token);
        setSendingRequest(false);
        props.setShowContact(false);
    }

    return (
        <div id="contact-form-modal">
            <form id="contact-form" className="off-white" action="javascript:void(0);">
                <div id="contact-head" className="align-center">
                    <h3 className="03906df5-68c6-4f6b-a577-40310d5d79a3">Contact Us</h3>
                    <div id="close-contact" className="16a7fbb4-7e6d-4217-9d6c-dee7d73b425b" onClick={() => props.setShowContact(false)}>Close</div>
                </div>
                <div id="contact-errors" className="row hide">
                    <div className="col-sm-12 align-center error 0e4c293d-1116-4e77-a721-97c2734b453a">Please enter a name and valid
                        email address</div>
                </div>
                <div id="contact-success" className="row hide">
                    <div className="col-sm-12 align-center accent-1-text d0cc0ab5-4d63-49a4-9f25-581cdcc4891a">Thank you, your ticket has been submitted.
                    </div>
                </div>
                <div className="spacer hidden-xs"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <select name="contactReason" id="contact-reason" value={props.reason} onChange={(e) => e ? props.setReason(e.target.value) : null}>
                            <option className="6550710f-5b44-43d4-8437-058c19c15a0b" value="email">I need to change my email address</option>
                            <option className="9e0917f1-7c85-4096-ae69-3b59697a37d3" value="mfa">I need to change my MFA phone number</option>
                            <option className="a9e6718f-87c9-4ed6-bd6c-2412beeb092b" value="facilities">I want to change my associated facilities</option>
                            <option className="afde582f-1be5-4568-a6d2-fb5a67d60524" value="other">Other</option>
                        </select>
                    </div>
                </div>
                <div className="spacer hidden-xs"></div>
                <div id="contact-blurb"></div>
                <div className="spacer hidden-xs"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <label htmlFor="contactApplication" className="label-question">
                            <span className="1f65d37a-ef94-403f-8044-ce8cae960a3c">Which application is your question about?</span>
                            <span className="tool-tip hide">
                                <a href="#tip"><i className="fa fa-info-circle"></i></a>
                                <span className="tip">
                                    <span className="text"><strong className="">BD BioScience</strong> <span className="36674d37-1dd9-4c53-8854-858242a82650">-
                                        text</span></span>
                                    <span className="text"><strong className="">Customer Care</strong> <span className="a764050b-95ac-4100-b8f3-ddc1742a9b09">- Current Info,
                                        Services, Content Library for Pyxis and Alaris Customers</span></span>
                                    <span className="text"><strong className="0efe60ee-1c39-4303-9e05-fa35d3e9aadf">Equipment Confirmation</strong> <span className="331d86d6-b873-4e3c-8682-a1ddffc84a7b">-
                                        Customer Site for
                                        approving equipment received</span></span>
                                    <span className="text"><strong className="d71ea8a8-f9eb-4703-9395-0460fea97f03">Learning Compass</strong> <span className="bc4048ca-a228-4f80-b97d-dce52dc9c12f">- Learning
                                        resources for Customers, Students and Users of many BD Products and
                                        services</span></span>
                                    <span className="text"><strong className="">BD Learning Academy</strong>
                                        <span className="">Blurb for LA</span></span>
                                </span>
                            </span>
                        </label>

                        <select
                            name="contactApplication"
                            id="contact-application"
                            value={applicationId}
                            onChange={(e) => e ? setApplicationId(e.target.value) : null}>
                            {ApplicationsOptions(props.applications)}
                        </select>
                    </div>
                </div>
                <div className="spacer hidden-xs"></div>
                <div className="row">
                    <div className="col-sm-4">
                        <label className="67c39545-3aae-4ee5-8627-0230b7081795" htmlFor="userName">Name</label>
                        <p>
                            <input
                                id="contact-name"
                                name="userName"
                                type="text"
                                value={props.contactName}
                                onChange={handleContactNameChange} />
                        </p>
                    </div>
                    <div className="col-sm-4">
                        <label className="f64966de-fb23-4f0a-bd72-2a22b15a2295" htmlFor="contactEmail">Email</label>
                        <p>
                            <input
                                id="contact-email"
                                name="contactEmail"
                                type="text"
                                value={props.contactEmail}
                                onChange={handleContactEmailChange} />
                        </p>
                    </div>
                    {
                        props.reason === "email" || props.reason === "" ?
                            <div className="col-sm-4">
                                <label className="df21f857-e122-4b4f-9c38-352455219f63" htmlFor="contactOldEmail">Old Email</label>
                                <p>
                                    <input
                                        id="contact-old-email"
                                        name="contactOldEmail"
                                        type="text"
                                        value={props.contactOldEmail}
                                        onChange={handleContactOldEmailChange}
                                        className={oldEmailClassName}
                                    />
                                </p>
                            </div>
                            : ""
                    }
                </div>
                <div className="spacer hidden-xs"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <p>
                            <span className="8bb3efaa-e97c-4970-9b43-7a1383031e10">Comments:</span>
                        </p>
                        <textarea
                            name="contactComments"
                            id="contact-comments"
                            cols={30}
                            rows={10}
                            value={props.message}
                            onChange={handleMessageChange}>
                        </textarea>
                    </div>
                </div>
                <div className="spacer hidden-xs"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <p id="contact-send-btn-container">
                            <button
                                className="579eb63f-d8c0-4854-bb71-861791d2699a"
                                type="submit"
                                id="contact-send"
                                disabled={sendingRequest}
                                onClick={() => { submitForm() }}>
                                {sendingRequest ? "Sending" : "Send"}
                            </button>
                        </p>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default Contact
